import withPrefix from '@/utils/withPrefix'

export default withPrefix('/brands/:brandId/sites/:siteId', [
  {
    path: '/site-importer',
    name: 'importer',
    component: () => import('./views/SiteImporterIndex'),
    meta: {
      auth: true
    }
  }
])
